export default __webpack_public_path__ + "static/media/accountability.166f011e.svg";